<div class="wrapper">
    <div class="container position-relative px-0">
            <!--<h5 class="main-title">{{patientPersonalInfo.PracticeName || 'N/A'}}</h5>-->
        <!--<div class="step-bar">-->
        <div>
            <!--<ul class="allergy-steps d-flex overflow-auto" #scrollintake>
                <li *ngIf="intakeCheckinSetting.data?.isAllergies == 'True'" class="patient-tab"
                    [ngClass]="url == 'intake' || url == 'allergy'? 'current active' : ''">
                  <a>
                    <div class="profile-bar ">
                      <object data="assets/images/Icons/Asset-1.svg" height="25"> </object>
                    </div>{{'intake.allergies'|translate}}
                  </a>
                </li>
                <li *ngIf="intakeCheckinSetting.data?.isMedicationHistory == 'True'" class="patient-tab"
                    [ngClass]="url == 'medication'? 'current active' : ''">
                  <a>
                    <div class="profile-bar">
                      <object data="assets/images/Icons/Asset-2.svg" height="25"> </object>
                    </div>{{'intake.medications'|translate}}
                  </a>
                </li>
                <li *ngIf="intakeCheckinSetting.data?.isFamilyHistory == 'True'" class="patient-tab"
                    [ngClass]="url == 'family-history'? 'current active' : ''">
                  <a>
                    <div class="profile-bar">
                      <object data="assets/images/Icons/Asset-4.svg" height="25"> </object>
                    </div>{{'intake.family_history'|translate}}
                  </a>
                </li>
                <li *ngIf="intakeCheckinSetting.data?.isSocialHistory == 'True'" class="patient-tab"
                    [ngClass]="url == 'social-history'? 'current active' : ''">
                  <a>
                    <div class="profile-bar">
                      <object data="assets/images/Icons/Asset-3.svg" height="25"> </object>
                    </div>{{'intake.social_history'|translate}}
                  </a>
                </li>
                <li *ngIf="intakeCheckinSetting.data?.isSurgicalhistory == 'True'" class="patient-tab" [ngClass]="url == 'past-surgical-history'? 'current active' : ''">
                  <a>
                    <div class="profile-bar">
                      <object data="assets/images/Icons/Asset-5.svg" height="25"> </object>
                    </div>{{'intake.past_surgical'|translate}}<br> {{'intake.history'|translate}}
                  </a>
                </li>
                <li *ngIf="intakeCheckinSetting.data?.isPasthospitilization == 'True'" class="patient-tab" [ngClass]="url == 'past-hospitalization-history'? 'current active' : ''">
                  <a>
                    <div class="profile-bar">
                      <object data="assets/images/Icons/Asset-7.svg" height="25"> </object>
                    </div>{{'intake.past_hospitalization'|translate}}
                  </a>
                </li>

            </ul>-->
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
<footer class="p-3 modal-open-intake">
    <div class="container p-0">
      <div class="d-flex justify-content-between align-items-center">
        <button class="btn btn-outline-primary" type="button" (click)="previousIntake()">{{'button.back'|translate}}</button>
        <!--<p *ngIf="IsNotMadisonPages" class="mb-0">({{pageNum}} {{'generic_text.of'|translate}} {{totalPages}})</p>-->
        <div *ngIf="!isPaymentEnable">
          <button class="btn btn-primary" type="button" (click)="onFinishIntake()" *ngIf="url=='past-hospitalization-history'">{{'button.finish'|translate}}</button>
          <button class="btn btn-primary" type="button" (click)="nextIntake()" *ngIf="url!='past-hospitalization-history'">{{'button.next'|translate}}</button>
        </div>

        <div *ngIf="isPaymentEnable">
          <button class="btn btn-primary" type="button" (click)="onFinishIntake()" *ngIf="url=='past-hospitalization-history' && !isDue">{{'button.finish'|translate}}</button>
          <button class="btn btn-primary" type="button" (click)="nextIntake()" *ngIf="url=='past-hospitalization-history' && isDue">{{'button.next'|translate}}</button>
          <button class="btn btn-primary" type="button" (click)="nextIntake()" *ngIf="url!='past-hospitalization-history'">{{'button.next'|translate}}</button>
        </div>

        <!-- Enable payment for live patient -->
        <!--
  <button class="btn btn-primary" type="button" (click)="onFinishIntake()" *ngIf="url=='past-hospitalization-history' && !isDue">{{'button.finish'|translate}}</button>
  <button class="btn btn-primary" type="button" (click)="nextIntake()" *ngIf="url=='past-hospitalization-history' && isDue">{{'button.next'|translate}}</button>
  -->
        <!-- Enable payment for testing -->
        <!--
      <button class="btn btn-primary" type="button" (click)="onFinishIntake()" *ngIf="url=='past-hospitalization-history' && !testing">{{'button.finish'|translate}}</button>
      <button class="btn btn-primary" type="button" (click)="nextIntake()" *ngIf="url=='past-hospitalization-history' && testing">{{'button.next'|translate}}</button>


      <button class="btn btn-primary" type="button" (click)="nextIntake()" *ngIf="url!='past-hospitalization-history'">{{'button.next'|translate}}</button>
  -->
      </div>
      </div>
  </footer>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="confirm-pharmacy">


  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3">{{'medication.pharmacy_popup_text'|translate}}</h5>
        <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal"
                id="closePharmacyModel">
          {{'button.no'|translate}}
        </button>
        <button type="button" id="closeConfirmPharmacy" (click)="nextFromPharmacy()"
                class="btn btn-primary rbtn">
          {{'button.yes'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>
